/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Activity_Center_Uploads_TitleInputs */



/**
* | output |
* | --- |
* | "Uploads & Embeddings" |
*
* @param {Activity_Center_Uploads_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const activity_center_uploads_title = /** @type {((inputs?: Activity_Center_Uploads_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activity_Center_Uploads_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uploads & Embeddings")
	return /** @type {LocalizedString} */ ("Uploads & Embeddings")
});